import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppBrowserModule } from '@app/app.browser.module';
import { environment } from './environments/environment';

import * as Sentry from '@sentry/angular';
import { SENTRY_CONFIG } from '@app/core/configs/sentry.config';

// import { create } from 'rxjs-spy';
// if (!environment.production) {
// 	const spy = create();
// 	spy.log();
// }

if (environment.production) {
	enableProdMode();

	Sentry.init({
		...SENTRY_CONFIG,
	});

	Sentry.configureScope(scope => {
		scope.setTag('logger', 'javascript');
	});

	['debug', 'log', 'info', 'warn', 'error', 'group', 'groupCollapsed', 'groupEnd', 'dir', 'dirxml', 'trace', 'profile'].forEach(method => ((window.console as any)[method] = () => void 0));
}

platformBrowserDynamic()
	.bootstrapModule(AppBrowserModule)
	.catch(err => console.error(err));
